module.exports = __webpack_public_path__ + "static/media/credits-icon.759f2ce8.png";